import { render, staticRenderFns } from "./GerenciarRepasses.vue?vue&type=template&id=57c49a25&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarRepasses.vue?vue&type=style&index=0&id=57c49a25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c49a25",
  null
  
)

export default component.exports